export function setUserLanguage(userData) {
  this.lang = userData ? userData.locale : "en";
}

export function checkLanguage(language) {
  if (language === "fr") {
    return "en";
  }
  return language;
}
